import { render, staticRenderFns } from "./ComponentAdmin.vue?vue&type=template&id=1b3dcaaf&"
import script from "./ComponentAdmin.vue?vue&type=script&lang=js&"
export * from "./ComponentAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports